import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import setFullHeight from './helpers/setFullHeight';
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import ArticleCards from './components/article-cards';
import categoryList from './components/categoryList';
import card from './components/card';
import looksPromo from './components/looksPromo';
import look from './components/look';
import select from './components/select';
import gallery from './components/gallery';
import product from './components/product';
import plpGrid from './components/plp-grid';
import pageHeader from './components/page-header';
import filter from './components/filter';
import stickyAdd from './components/sticky-add';
import cartAdd from './components/cart-add';
import swatches from './components/swatches';
// import features from './components/features';
import features from './components/features-click';
import sg from './components/sg'; // sizeguide table tabs
import footer from './components/footer';
import footerUsp from './components/footer-usp';
import breadcrumbs from './components/breadcrumbs';
import desktopNavigation from './components/desktop-navigation';
import mobileNavigation from './components/mobile-navigation';
import header from './components/header';
import cart from './components/cart';
import hoverGroup from './components/hover-group';
import imgScroll from './components/img-scroll';
import sideMenu from './components/sidemenu';
import search from './components/search';
import filterApply from './components/filter-apply';
import anchorScroll from './components/anchor-scroll';
import accordeon from './helpers/accordeon';
import account from './components/account';
import textarea from './components/textarea';
import textPage from './components/text-page';
import searchPage from './components/search-page';
import video from './components/video';
import { isSafari } from './helpers/exportFunc';
// import customSelect from './helpers/custom-select';
// import addressFields from './components/address-fields';
import newsletterPopup from './components/newsletter-popup';
import inputMask from './components/input-mask';
import newsletterForm from './components/newsletter';
import announcementBar from './components/announcement-bar';
import pshCartCarousel from './components/psh-cart-carousel';
import brandShowcase from './components/brand-showcase';
import slider from './components/slider';

export default () => {
	init();
	general();

	function init() {
		setFullHeight(); //Set VH variable for mobile safari 100VH, use scss mixin fullheight()
		cart();
		imgScroll();
		categoryList();
		card();
		looksPromo();
		look();
		gallery();
		product();
		plpGrid();
		pageHeader();
		stickyAdd();
		cartAdd();
		// productTabs();
		swatches();
		features();
		sg();
		breadcrumbs();
		hoverGroup();
		footer();
		// sideMenu();
		anchorScroll();
		search();
		filterApply();
		accordeon({
			onComplete: function() {
				ScrollTrigger.refresh();
			}
		});
		account();
		textarea();
		textPage();
		searchPage();
		video();
		header();
		filter();
		isSafari() ? document.body.classList.add('is-safari') : false;
		newsletterPopup();
		inputMask();
		newsletterForm();
		ScrollTrigger.refresh();
		pshCartCarousel();
		brandShowcase();
		select();
	}

	function general() {
		desktopNavigation();
		sideMenu();
		footerUsp();
		announcementBar();
		slider();
	}

	const swup = new Swup({
		animateHistoryBrowsing: true,
		plugins: [
			new SwupPreloadPlugin(),
			new SwupScriptsPlugin({
				// body: true,
				optin: true
			})
		]
	});

	// before swup content replace
	swup.on('transitionStart', () => {
		const videoContainer = document.querySelector('[data-video-modal-el="modal"]');

		if (videoContainer) {
			videoContainer.setAttribute('aria-hidden', 'true');
		}

		document.dispatchEvent(new CustomEvent('close-navigation'));
		document.dispatchEvent(new CustomEvent('close-search'));
	});

	swup.on('animationOutStart', () => {
		const sidemenu = document.querySelector('.js-sidemenu');
		if (sidemenu) { }
		sidemenu.classList.remove('sidemenu--opened');
		document.body.classList.remove('is-sidemenu-opened');
	});

	swup.on('animationOutDone', () => {
		const cartAddPopup = document.querySelector('.cart-add');
		document.body.classList.remove('is-cart-add-visible');
		if (cartAddPopup) {
			cartAddPopup.remove();
		}

		let newsletterError = document.querySelector('.subscribe input+div');

		if (newsletterError) {
			newsletterError.remove();
			// console.log('newsletterError removed');
		}
	});

	const swupContentReplacedEvent = new CustomEvent('content:replaced');

	swup.on('contentReplaced', function() {

		document.dispatchEvent(swupContentReplacedEvent);

		ScrollTrigger.killAll();

		init();

		const section = document.querySelector('section');
		const media = section.querySelectorAll('img, video, iframe');

		if (!media.length) {
			return;
		}

		gsap.to(media, {
			filter: 'blur(32px)',
			duration: 0
		});

	});

	swup.on('animationInStart', function() {
		window.scrollTo(0, 0);
		const section = document.querySelector('section');
		const media = section.querySelectorAll('img, video, iframe');

		if (!media.length) {
			return;
		}

		gsap.to(media, {
			filter: 'blur(0px)',
			duration: 0.4
		});
	});

};
